const normalize = (value: string) => value.normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, '');

// A bounded edit-distance fallback; exact/substring results keep their existing priority.
export function matchesProductTypo(name: string, input: string): boolean {
    const query = normalize(input), text = normalize(name);
    if (!query || query.length > 32 || text.length > 128) return false;
    if (text.includes(query)) return true;
    if (query.length < 2) return false;
    const allowance = query.length >= 6 ? 2 : 1;
    const lengths = query.length === 2 ? [2] : [query.length - 1, query.length, query.length + 1];
    for (const length of lengths) {
        for (let start = 0; start + length <= text.length; start++) {
            const candidate = text.slice(start, start + length);
            let previous = Array.from({ length: length + 1 }, (_, index) => index);
            for (let i = 1; i <= query.length; i++) {
                const current = [i];
                for (let j = 1; j <= length; j++) current[j] = Math.min(previous[j] + 1, current[j - 1] + 1,
                    previous[j - 1] + (query[i - 1] === candidate[j - 1] ? 0 : 1));
                previous = current;
            }
            if (previous[length] <= allowance) return true;
        }
    }
    return false;
}

export function filterProductNames<T extends { name: string }>(products: T[], search: string): T[] {
  const query = search.trim().toLocaleLowerCase();
  const exact = products.filter(product => product.name.toLocaleLowerCase().includes(query));
  return exact.length || !query ? exact : products.filter(product => matchesProductTypo(product.name, search));
}
